import Vue from 'vue'
import alasqlJs from 'alasql'

var XLSX = require('xlsx')
alasqlJs.setXLSX(XLSX)

const alasql = {
  install() {
    Vue.prototype.alasql = alasqlJs
  }
}

Vue.use(alasql)